export default {"src":"/_next/static/media/animated-logo-cropped.e7782bb3.gif","height":428,"width":478,"blurWidth":0,"blurHeight":0};